import { gql } from "@apollo/client";

const NewPasswordMutation = gql`
  mutation newPassword($password: String!) {
    newPassword(input: { tpassword: $password }) {
      boolean
    }
  }
`;

const hash = "604fdb86eae696fadd10e548b24c9132d51931cc83a7cc49420f9cff90e378c1";

export { NewPasswordMutation, hash };
